<template>
  <div class="vote-stars">
    <div class="text">
      <span v-if="canVote">{{ domainStore.translate('discuss.thought.voting.stars.my-vote') }}</span>
      <span v-else>{{ domainStore.translate('discuss.thought.voting.stars.average-vote') }}</span>
    </div>
    <a
      v-for="n in 4"
      :key="n"
      @click="canVote ? onVote($event, n) : null"
      :class="starClass(n)"
      @mouseover="sethoverStar(n)"
      @mouseleave="sethoverStar(null)"
      type="button"
      v-tooltip.bottom="starsSummaryText(n)"
    >
      <span v-if="useStarHalf(n)">
        <font-awesome-icon :icon="['fas', 'star-half-alt']" />
      </span>
      <span v-else>
        <font-awesome-icon :icon="['fas', 'star']" />
      </span>
    </a>
    <span class="visually-hidden">{{ starsSummaryText }}</span>
  </div>
</template>

<script>
import { toRefs } from '@vue/runtime-core';
import useThoughtEvents from '@/composables/thought/useThoughtEvents';
import { ref } from 'vue';
import { domainStore } from '@/store/domain-store';

export default {
  name: 'VoteStars',
  props: {
    voteStatus: {
      require: true,
      type: Number,
    },
    canVote: {
      require: true,
      type: Boolean,
    },
  },

  emits: ['vote-value'],
  setup(props, context) {
    const { voteStatus, canVote } = toRefs(props);
    const { emitVoteValue } = useThoughtEvents(context);

    //For Hover Event
    const hoverStars = ref(null);

    // --------------METHOD-------------
    function onVote(event, number) {
      emitVoteValue(event, number);
    }
    function sethoverStar(number) {
      hoverStars.value = number;
    }
    function starsSummaryText(number) {
      if (canVote.value) {
        return number == voteStatus.value
          ? domainStore('discuss.thought.voting.stars.message.already-voted')
          : domainStore('discuss.thought.voting.stars.message.can-vote');
      } else {
        return domainStore('discuss.thought.voting.stars.message.avg-result', {
          count: isNaN(voteStatus.value) ? '0' : voteStatus.value,
        });
      }
    }
    function useStarHalf(number) {
      return voteStatus.value > number - 1 && voteStatus.value < number;
    }
    // --------------CLASS-------------
    function starClass(number) {
      return {
        color: true,
        has_voted: voteStatus.value > number - 1 && (canVote.value ? hoverStars.value == null : true),
        hover_color: canVote.value && hoverStars.value != null && hoverStars.value >= number,
        voting_disabled: !canVote.value,
        star: true,
      };
    }

    return {
      domainStore,
      // ----CLASS----
      starClass,
      // ----METHOD----
      onVote,
      sethoverStar,
      useStarHalf,
      starsSummaryText,
    };
  },
};
</script>

<style scoped lang="scss">
.star {
  font-size: 1.2em;
}
.svg-inline--fa {
  margin-top: -1.2em;
}

.wdw-widgets a:not(.btn) {
  color: #6b7881;

  &:hover {
    color: #6b7881;
  }
  &.has_voted {
    color: #e96f35;
    &.voting_disabled {
      color: #279ae9;
    }
    &.hover_color {
      color: #e96f35;
    }
  }
  &.hover_color {
    color: #e96f35;
  }
  &.voting_disabled {
    cursor: default;
  }
}
.text {
  font-size: 0.75rem;
}
.vote-stars .text {
  padding-bottom: 0.4rem;
}
</style>
